import api from 'api'

export async function getJetTimesheetPhotoUrl(
  associationId: number
): Promise<string> {
  const response = await api.get(
    `/admin/jet/call_report/${associationId}/timesheet_photo`
  )
  return response.data.url
}
